require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-tutoring-now-available-from-code-fellows.json") })
        }
      }, "path---blog-tutoring-now-available-from-code-fellows");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-tutoring-now-available-from-code-fellows!./.cache/json/blog-tutoring-now-available-from-code-fellows.json
// module id = 1117
// module chunks = 231608221292675